<div mat-dialog-title>
  <h2>{{"surveyTasks.targetAudienceByRegion" | translate}}</h2>
  <button mat-icon-button class="close" aria-label="Close" mat-dialog-close>
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="mat-dialog-body">
    <div class="mat-dialog-inner mt-3 mb-2">
      <h3 class="subtitle-form fontSemiBold">
        {{data.record.length}} <span class="fontRegular grey-color">{{"surveyTasks.targetRegions" | translate}}</span>
      </h3>
    </div>
    <div class="list_group_info p-0 mb-0">
      <ul>
        @for (item of data.record; track $index) {
        <li class="item_info">
          <div class="d-flex justify-content-between align-items-center"> {{item.name}}
            <span class="item_info_count">
              <span class="fontSemiBold"> {{item.rate}} </span>
              <span class="fontRegular"> / {{item.totalRate}} </span>
              <span class="title_data_regular grey-color ">
                {{"manageSurveys.sample" | translate}}
              </span>
            </span>
          </div>
        </li>
      }
      </ul>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button type="button" class="btn-grey" mat-dialog-close>
    {{"forms.Close" | translate}}
  </button>
</mat-dialog-actions>
